<template>
  <v-container fluid class="pt-1 pa-0">
    <v-row dense>
      <v-col
        v-if="$vuetify.breakpoint.smAndUp"
        cols="12"
        :sm="leftCol.sm"
        :md="twoColumn ? null : leftCol.md"
        :xl="twoColumn ? leftCol.xlTwoCol : leftCol.xl"
        class="left-column d-flex flex-column"
        style="gap: 12px"
      >
        <slot name="left">
          <span>Default Left Section</span>
        </slot>
        <slot v-if="$vuetify.breakpoint.smOnly" name="right">
          <span>Default Right Section</span>
        </slot>
      </v-col>
      <v-col
        class="main-column"
        cols="12"
        :sm="mainCol.sm"
        :md="twoColumn ? null : mainCol.md"
        :xl="twoColumn ? mainCol.xlTwoCol : mainCol.xl"
      >
        <slot name="main">
          <span>Default Main Section</span>
        </slot>
      </v-col>
      <v-col
        v-if="!twoColumn"
        cols="12"
        :sm="rightCol.sm"
        :md="rightCol.md"
        :xl="rightCol.xl"
        class="right-column align-self-start"
      >
        <slot name="right">
          <!-- <span>Default Right Section</span> -->
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ThreeColumnLayout",
  props: {
    dense: {
      default: false,
      type: Boolean,
    },
    // Left column width configuration
    leftCol: {
      type: Object,
      default: () => ({
        sm: 4,
        md: 3,
        xl: 2,
        xlTwoCol: 3,
      }),
    },
    // Main column width configuration
    mainCol: {
      type: Object,
      default: () => ({
        sm: 8,
        md: 6,
        xl: 8,
        xlTwoCol: 9,
      }),
    },
    // Right column width configuration
    rightCol: {
      type: Object,
      default: () => ({
        sm: 4,
        md: 3,
        xl: 2,
      }),
    },
  },
  computed: {
    twoColumn() {
      return this.deviceSize.tablet;
    },
  },
};
</script>
